const setData = (payload) => {

    localStorage.setItem('react-billableme', payload);

    return true;

}

export default setData;